import React, { useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { Button, Form, message, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";

import { UPDATE_PROJECT_CORS_MUTATION } from "../../helpers/graphql/project";

interface Props {
  project: { id: string; allowOrigins: string };
}

interface AllowOriginsInputValue {
  id: string;
  allowOrigins: string | string[];
}

export function UpdateEndpointCors({ project }: Props) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [updateEndpointCors, { loading, data: newEndpointData }] = useMutation(
    UPDATE_PROJECT_CORS_MUTATION,
    {
      onError: (error) => {
        message.error(error.toString());
      },
    },
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSubmit = async (values: AllowOriginsInputValue) => {
    updateEndpointCors({
      variables: {
        id: project.id,
        allowOrigins: Array.isArray(values.allowOrigins)
          ? values.allowOrigins
          : (values.allowOrigins as string).split(","),
      } as AllowOriginsInputValue,
    });
    setIsModalVisible(false);
  };

  // events run after updated the endpoint cors
  useEffect(() => {
    if (newEndpointData) {
      message.success("Saved changes");
    }
  }, [newEndpointData]);

  return (
    <>
      <Button type="ghost" onClick={showModal}>
        Security Settings
      </Button>

      <Modal
        title="RPC Allow Origins"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button onClick={handleCancel} key="back">
            Cancel
          </Button>,
          <Button
            form="updateEndpointForm"
            key="submit"
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Save
          </Button>,
        ]}
      >
        <Form<AllowOriginsInputValue>
          id={`updateEndpointForm`}
          name={`updateEndpointForm`}
          layout="vertical"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 100 }}
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item name="allowOrigins" initialValue={project?.allowOrigins}>
            <TextArea
              placeholder='Split the URL by comma ","'
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
